import Head from 'next/head';
import parse from 'html-react-parser';
import styled from 'styled-components';
import type { HTMLLayoutSlot } from '@amplience/content-types/typings/s-html-layout';
import { media } from '@storefront/lib-global/stylings';

const S = {
  SectionContainer: styled.section`
    align-items: center;
    display: flex;
    flex-direction: column;
    max-width: 1440px;
    @media ${media.greaterThan('xl')} {
      margin: auto;
      padding: auto;
    }
  `,
};

export type HTMLContentProps = HTMLLayoutSlot;

export function HTMLContent({ htmlContent }: HTMLContentProps) {
  const { headTextArea, bodyTextArea } = htmlContent;
  const bodyHTMLContent = { __html: bodyTextArea };
  const parsedHTMLHeadContent = parse(headTextArea);

  return (
    <>
      <Head>{parsedHTMLHeadContent}</Head>
      <S.SectionContainer dangerouslySetInnerHTML={bodyHTMLContent} id="html-layout-slot-input" />
    </>
  );
}

export default HTMLContent;
